export default {
  //* emailBadge ---------------------------------------------------------------------------------------------------------------

  async emailBadge({ rootGetters, commit }) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(base_address + "/dashboard/emailBadge", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setEmailBadge", resp_json);
      return true;
    }
    return false;
  },

  //* quotesValueBadge ---------------------------------------------------------------------------------------------------------------

  async quotesValueBadge({ rootGetters, commit }) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(base_address + "/dashboard/quotesValueBadge", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setQuotesValueBadge", resp_json);
    }
  },

  //* quotesBadge ---------------------------------------------------------------------------------------------------------------

  async quotesBadge({ rootGetters, commit }) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(base_address + "/dashboard/quotesBadge", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setQuotesBadge", resp_json);
    }
  },

  //* conversion ---------------------------------------------------------------------------------------------------------------

  async conversion({ rootGetters, commit }, opt) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
    };

    if(opt.lucee){
      opts.body = JSON.stringify({ lucee: true })
    }

    const response = await fetch(base_address + "/dashboard/conversion/" + opt.comp, opts).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setConversion", resp_json);
    }
  },

  //* nationality ---------------------------------------------------------------------------------------------------------------

  async nationality({ rootGetters, commit }, opt) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
    };

    if(opt.lucee){
      opts.body = JSON.stringify({ lucee: true })
    }

    const response = await fetch(base_address + "/dashboard/nationality", opts).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setNationality", resp_json);
    }
  },

  //* annoCorrente ---------------------------------------------------------------------------------------------------------------

  async annoCorrente({ rootGetters, commit }, opt) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
      body: JSON.stringify(opt)
    };

    const response = await fetch(base_address + "/dashboard/annoCorrente", opts).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      resp_json = resp_json['ANNOCORRENTE']
      return parseInt(resp_json.replaceAll('"', ''))
    }
  },

  //* aperturaChiusura ---------------------------------------------------------------------------------------------------------------

  async aperturaChiusura({ rootGetters, commit }, opt) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
      body: JSON.stringify(opt)
    };

    const response = await fetch(base_address + "/dashboard/aperturaChiusura", opts).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      resp_json = resp_json['STAGIONI']
      return resp_json
    }
  },

  //* stagioni ---------------------------------------------------------------------------------------------------------------

  async stagioni({ rootGetters, commit }, opt) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
      body: JSON.stringify(opt)
    };

    const response = await fetch(base_address + "/dashboard/stagioni", opts).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      resp_json = resp_json['STAGIONI']
      commit("setStagioni", resp_json);
      return resp_json
    }
  },

  //* kpi/preventivi ---------------------------------------------------------------------------------------------------------------

  async preventivi({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/preventivi/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/categoriePreventivi ---------------------------------------------------------------------------------------------------------------

  async categoriePreventivi({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/categoriePreventivi/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/primaRisposta ---------------------------------------------------------------------------------------------------------------

  async primaRisposta({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/primaRisposta/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/bookingWindow ---------------------------------------------------------------------------------------------------------------

  async bookingWindow({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/bookingWindow/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/occupazioneMedia ---------------------------------------------------------------------------------------------------------------

  async occupazioneMedia({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/occupazioneMedia/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/valoreMedio ---------------------------------------------------------------------------------------------------------------

  async valoreMedio({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/valoreMedio/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/tassoConv ---------------------------------------------------------------------------------------------------------------

  async tassoConv({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/tassoConv/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/cancellazioni ---------------------------------------------------------------------------------------------------------------

  async cancellazioni({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/cancellazioni/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/nottiConfermate ---------------------------------------------------------------------------------------------------------------

  async nottiConfermate({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/nottiConfermate/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/valoriEconomici ---------------------------------------------------------------------------------------------------------------

  async valoriEconomici({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/valoriEconomici/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/richiestePeriodo ---------------------------------------------------------------------------------------------------------------

  async richiestePeriodo({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/richiestePeriodo/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/nazionalitaContatti ---------------------------------------------------------------------------------------------------------------

  async nazionalitaContatti({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/nazionalitaContatti/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/indiceConversione ---------------------------------------------------------------------------------------------------------------

  async indiceConversione({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/indiceConversione/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* kpi/statiPreventivi ---------------------------------------------------------------------------------------------------------------

  async statiPreventivi({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/kpi/statiPreventivi/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
        body: JSON.stringify(comp)
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json
    }
  },

  //* totalRequest ---------------------------------------------------------------------------------------------------------------

  async totalRequest({ rootGetters, commit }, comp) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    const response = await fetch(
      base_address + "/dashboard/totalRequest/" + comp,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setTotalRequest", resp_json);
    }
  },

  //* nationalityConversion ---------------------------------------------------------------------------------------------------------------

  async nationalityConversion({ rootGetters, commit }, opt) {
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
    };

    if(opt.lucee){
      opts.body = JSON.stringify({ lucee: true })
    }

    const response = await fetch(
      base_address + "/dashboard/nationalityConversion/" + opt.comp,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors",
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setNationalityConversion", resp_json);
    }
    return resp_json;
  },

  //* forceUpdateAll ---------------------------------------------------------------------------------------------------------------

  async forceUpdateAll({ rootGetters }) {
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok;
    var response = await fetch(base_address + "/dashboard/forceUpdate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
    }).catch((e) => console.log(e));
    if (response.ok) {
      return true;
    }
    return true;
  },
};
